<template>
  <div class="chart-wrapper">
    <canvas ref="chart"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js';

export default {
  name: 'CampaignTimelineChart',
  props: {
    chartData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      chart: null
    };
  },

  mounted() {
    this.renderChart();
  },

  watch: {
    chartData: {
      deep: true,
      handler() {
        this.updateChart();
      }
    }
  },

  methods: {
    renderChart() {
      const ctx = this.$refs.chart.getContext('2d');
      
      const defaultOptions = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'top',
          labels: {
            padding: 20,
            usePointStyle: true
          }
        },
        tooltips: {
          backgroundColor: '#2d3748',
          titleFontSize: 13,
          bodyFontSize: 12,
          padding: 12,
          cornerRadius: 8,
          mode: 'index',
          intersect: false
        },
        hover: {
          mode: 'index',
          intersect: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              fontColor: '#718096'
            }
          }],
          yAxes: [{
            gridLines: {
              color: '#e2e8f0',
              zeroLineColor: '#e2e8f0'
            },
            ticks: {
              fontColor: '#718096',
              beginAtZero: true,
              callback: function(value) {
                return value.toLocaleString();
              }
            }
          }]
        },
        elements: {
          line: {
            tension: 0.4
          },
          point: {
            radius: 4,
            hitRadius: 10,
            hoverRadius: 6
          }
        },
        animation: {
          duration: 1000
        }
      };

      this.chart = new Chart(ctx, {
        type: 'line',
        data: this.chartData,
        options: { ...defaultOptions, ...this.options }
      });
    },

    updateChart() {
      if (this.chart) {
        this.chart.data = this.chartData;
        this.chart.update();
      }
    }
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
};
</script>

<style scoped>
.chart-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
